import { useState, useEffect } from 'react'
import { supabase } from '../services/supabase'

export function useOnlineStatus() {
  const [isOnline, setIsOnline] = useState(false) // ⭐ Empieza en false
  const [justWentOnline, setJustWentOnline] = useState(false)
  const [checking, setChecking] = useState(true)

  // ⭐ FUNCIÓN: Verificar conexión REAL con Supabase
  async function verificarConexionReal() {
    if (!navigator.onLine) {
      return false
    }

    try {
      // Intentar hacer una query simple a Supabase
      const { error } = await supabase
        .from('clients')
        .select('id')
        .limit(1)
        .single()

      // Si no hay error o es "no rows", significa que HAY conexión
      const conectado = !error || error.code === 'PGRST116'
      
      console.log('🔍 Verificación de conexión:', conectado ? '✅ ONLINE' : '❌ OFFLINE')
      return conectado
    } catch (err) {
      console.log('🔍 Verificación de conexión: ❌ OFFLINE (error)', err.message)
      return false
    }
  }

  useEffect(() => {
    let interval

    async function inicializar() {
      console.log('🚀 Inicializando detección de conexión...')
      
      // Verificación inicial
      const conectado = await verificarConexionReal()
      setIsOnline(conectado)
      setChecking(false)
      
      if (conectado) {
        console.log('✅ Conexión inicial establecida')
      } else {
        console.log('⚠️ Sin conexión inicial - modo offline')
      }
    }

    function handleOnline() {
      console.log('🟢 Evento ONLINE - verificando conexión real...')
      verificarConexionReal().then(conectado => {
        if (conectado && !isOnline) {
          setIsOnline(true)
          setJustWentOnline(true)
          setTimeout(() => setJustWentOnline(false), 1000)
          console.log('✅ Conexión restaurada')
        }
      })
    }

    function handleOffline() {
      console.log('🔴 Evento OFFLINE detectado')
      setIsOnline(false)
    }

    // Verificación periódica cada 5 segundos
    async function checkConnection() {
      if (navigator.onLine) {
        const conectado = await verificarConexionReal()
        
        if (conectado !== isOnline) {
          console.log('🔄 Estado actualizado:', conectado ? 'ONLINE' : 'OFFLINE')
          setIsOnline(conectado)
          
          if (conectado && !isOnline) {
            setJustWentOnline(true)
            setTimeout(() => setJustWentOnline(false), 1000)
          }
        }
      } else if (isOnline) {
        setIsOnline(false)
      }
    }

    // Inicializar
    inicializar()

    // Eventos del navegador
    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    // Verificación periódica
    interval = setInterval(checkConnection, 5000)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
      clearInterval(interval)
    }
  }, [isOnline])

  return { isOnline, justWentOnline, checking }
}